import { render, staticRenderFns } from "./editTax.vue?vue&type=template&id=1ac1dc84&scoped=true&"
import script from "./editTax.vue?vue&type=script&lang=js&"
export * from "./editTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac1dc84",
  null
  
)

export default component.exports